import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { EquipmentsApi } from '../../../../api/equipments/equipments.api';
import { Equipment, PagedResult } from '../../../../interfaces';

export function ValidateAutocomplete(): { required: boolean } {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EquipmentLegacyComponent),
  multi: true
};

@Component({
  selector: 'equipment-legacy',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class EquipmentLegacyComponent implements ControlValueAccessor, OnInit {
  public equipments: Equipment[] = [];
  public inputValue = new FormControl();
  public hasSelectedEquipment: boolean;
  public selectedEquipment: Equipment;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private equipmentsApi: EquipmentsApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
  }

  ngOnInit(): void {
    this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      this.equipments = [];
      if (value) {
         this.searchEquipments({ name_or_number_contains: value });
      }
    });
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  searchEquipments(query?): void {
    this.loading = true;
    this.equipmentsApi.getEquipments(query).subscribe((result: PagedResult) => {
      this.loading = false;
      this.equipments = result.items;
    });
  }

  writeValue(equipmentId: any): void {
    if (equipmentId) {
      this.equipmentsApi.searchOne(equipmentId).subscribe((equipment) => {
        this.selectedEquipment = equipment;
        this.hasSelectedEquipment = true;
        this.inputValue.setErrors(null);
      });
    } else {
      this.deselectEquipment();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedEquipment(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedEquipment = this.equipments.find((equipment) => equipment.id === this.inputValue.value);
      this.hasSelectedEquipment = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectEquipment(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedEquipment = null;
    this.hasSelectedEquipment = false;
    this.inputValue.setErrors(null);
  }
}
